import './App.scss';
import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { IRoute, routes } from './utils/navigation/routes';
import { isAndroid, isIOS } from 'react-device-detect';
import navigateParams from './utils/navigation/navigateParams';
import { useTranslation } from 'react-i18next';
import { alert, Stack, Text3, skinVars } from '@telefonica/mistica';
import { TrackingEvents } from './utils/dataTransformation/tracking';
import dayjs from 'dayjs';

const App: React.FC = () => {
    require('dayjs/locale/es');
    dayjs.locale('es');
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const [openAlert, setOpenAlert] = useState<boolean>(false);

    const sendToNative = (url: string, host?: boolean) => {
        const type = 'modeModal-backgroundWhite';
        if (navigateParams(type, url, {}, {}, '', '', host)) {
            navigate(url);
        }
    };

    if (isIOS) {
        window.postActionNative = function (msg: any) {
            const parseMsg = JSON.parse(msg);
            if (msg && parseMsg.data.id === 'PROFILE') {
                const queryParams = {
                    clientType: new URLSearchParams(window.location.search).get('clientType'),
                };
                const isQueryParams = new URLSearchParams(window.location.search).has('clientType') ? queryParams : {};
                navigateParams('navigation-global-profile', '/profile', isQueryParams);
            }

            if (msg && parseMsg.data.id === 'INFO_SPEED_TEST') {
                sendToNative(`/fiber/fiber-modal-test-information`);
            }

            if (msg && parseMsg.data.id === 'CALLDIVERT') {
                handleAlert();
            }
            if (msg && parseMsg.data.id === 'ORDERS') {
                navigateParams('modeFlow-backgroundBlue', '/profile/orders/faqs', {}, {}, t('titleFAQsOrders'), '');
            }
        };
    }

    if (isAndroid) {
        window.postActionNative = function (msg: any) {
            if (msg && msg.data.id === 'PROFILE') {
                const queryParams = {
                    clientType: new URLSearchParams(window.location.search).get('clientType'),
                };
                const isQueryParams = new URLSearchParams(window.location.search).has('clientType') ? queryParams : {};
                navigateParams('navigation-global-profile', '/profile', isQueryParams);
            }

            if (msg && msg.data.id === 'INFO_SPEED_TEST') {
                sendToNative(`/fiber/fiber-modal-test-information`);
            }

            if (msg && msg.data.id === 'CALLDIVERT') {
                handleAlert();
            }
            if (msg && msg.data.id === 'ORDERS') {
                navigateParams('modeFlow-backgroundBlue', '/profile/orders/faqs', {}, {}, t('titleFAQsOrders'), '');
            }

            if (msg && msg.data.id === 'PERMISSIONS_REQUEST') {
                const isCamera = msg.data.data.id === 'CAMERA';

                if (isCamera) {
                    const navigationDAON = msg.data.data.data.status === 'SUCCESS';
                    if (navigationDAON) {
                        if (navigateParams('modeBrowser', `${window.location.origin}/obd/daon`, {}, {}, '')) {
                            window.open(`${window.location.origin}/obd/daon`, '_blank');
                        }
                    }
                }
            }
        };
    }

    const handleAlert = () => {
        if (!openAlert) {
            setOpenAlert(true);
            alert({
                className: 'callDivert',
                title: t('callDivert'),
                message: (() => {
                    return (
                        <Stack space={16}>
                            <Text3 light color={skinVars.colors.borderHigh}>
                                {t('calldivertalerttext1')}
                            </Text3>
                            <Text3 light color={skinVars.colors.borderHigh}>
                                {t('calldivertalerttext2')}
                            </Text3>
                            <Text3 light color={skinVars.colors.borderHigh}>
                                {t('calldivertalerttext3')}
                            </Text3>
                        </Stack>
                    );
                })() as any,
                acceptText: t('buttonUnderstoodFeedback'),
                onAccept() {
                    setOpenAlert(false);
                },
            });
        }
    };

    useEffect(() => {
        window.addEventListener('DOMContentLoaded', () => {
            const exceptions = ['/home', '/bills', '/explore', '/support'];

            if (exceptions.every((url: string) => url !== location.pathname!.split('?')[0])) {
                trackingScreenView();
            }
        });
    }, []);

    return (
        <>
            <Routes>
                <>
                    {routes.map((route: IRoute, index: number) => {
                        const { path, element } = route;
                        return <Route key={index} path={path} element={element} />;
                    })}
                </>
            </Routes>
        </>
    );
};

export default App;
